import React from 'react';

import { withRouter } from '@/hooks';
import { Box, Grid } from '@mui/material';
import dashboardEmptyActionList from '../Common/Icons/svg/empty.svg';


const ErrorPage = (props: any) => {
  console.warn(props);

  return (
    <Box height={1} width={1}>
      <Grid item xs={12}>
        <Grid container justifyContent={'center'} alignItems={'center'}>
          <Grid item xs={12} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
            <h1>404</h1>
            <img alt={'err-image'} src={dashboardEmptyActionList} width={'33%'} style={{ opacity: 0.6 }}/>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default withRouter(ErrorPage);
